import Identified from '../type/base/Identified';

export default ({id}: Identified): string => `${id}`;
